module.exports = __webpack_public_path__ + "static/mr_Burak_at_Qatar-0a1207d73eb1889668b7106db0960691.jpeg";